
module.exports = require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/socket.io-client/index.js
 ** module id = 155
 ** module chunks = 0
 **/